import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const LINKS = [{
  to: '/',
  label: 'Home'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/expertise',
  label: 'Expertise'
}, {
  to: '/career',
  label: 'Career'
}, {
  to: '/impact',
  label: 'Impact'
}, {
  to: '/framework',
  label: 'Framework'
}, {
  to: '/credentials',
  label: 'Credentials'
}, {
  to: '/insights',
  label: 'Insights'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Nav() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-ink-900/95 backdrop-blur" data-id="element-35" data-mp="1uobsvqxyei8u">
      <div className="mx-auto flex h-20 max-w-[1400px] items-center justify-between px-6 lg:px-10" data-id="element-36" data-mp="1yqoy8e8sge53">
        <Link to="/" className="flex items-baseline gap-3 text-white" data-id="element-37" data-mp="23oqi31e1ghhm">
          <span className="text-xl tracking-wide" data-id="element-38" data-mp="23mxbfm3fdx9m">Christine Eaton</span>
          <span className="hidden text-xs tracking-wider2 text-gold-300 xl:inline" data-id="element-39" data-mp="1y79qpkz7eqm9">
            GLOBAL SOURCING TRANSFORMATION
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-7 lg:flex" data-id="element-40" data-mp="1p4gxvdadi6ub">
          {LINKS.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({
          isActive
        }) => `border-b-2 pb-1 text-base transition-colors duration-150 ease-exec focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 ${isActive ? 'border-gold-400 text-gold-200' : 'border-transparent text-slate-200 hover:text-gold-300'}`} data-id="element-41" data-mp="1k7797zut5z7j">
              {link.label}
            </NavLink>)}
        </nav>

        <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-label={open ? 'Close navigation menu' : 'Open navigation menu'} className="text-white lg:hidden" data-id="element-42" data-mp="2vsnvkduyutpz">
          {open ? <XIcon className="h-7 w-7" data-id="element-43" data-mp="k6dezpqiq09z" /> : <MenuIcon className="h-7 w-7" data-id="element-44" data-mp="k5am5c9mxnrf" />}
        </button>
      </div>

      {open ? <nav aria-label="Mobile" className="border-t border-white/10 bg-ink-900 px-6 py-4 lg:hidden" data-id="element-45" data-mp="p4n7ttorsosf">
          <ul className="grid gap-1" data-id="element-46" data-mp="a7wfu5hfefcu">
            {LINKS.map(link => <li key={link.to} data-id="element-47" data-mp="f70ql0k00l5a">
                <NavLink to={link.to} end={link.to === '/'} className={({
            isActive
          }) => `block py-2 text-lg transition-colors duration-150 ease-exec ${isActive ? 'text-gold-200' : 'text-slate-200 hover:text-gold-300'}`} data-id="element-48" data-mp="f8bqgpabp8r4">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
        </nav> : null}
    </header>;
}